/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { styled } from '@abyss/ui/tools/styled';
import { useForm } from '@abyss/ui/form/hooks/useForm';
import { FormControl } from '@abyss/ui/form/FormControl';
import { TextInput } from '@abyss/ui/form/TextInput';
import { ErrorMessage } from '@abyss/ui/form/ErrorMessage';
import { Button } from 'src/common/Button';
import { Flex } from '@abyss/ui/base/Flex';
import PropTypes from 'prop-types';
import { useProvidersSearch } from 'src/hooks/useProvidersSearch';
import { AlertContext } from 'src/tools/AlertContext';
import { useModel } from '@abyss/ui/form/hooks/useModel';

const ActionButtons = styled.div({
  marginTop: 25,

  '> *:first-child': {
    marginRight: 12,
  },
});

export const FindForm = ({ setProviders }) => {
  const form = useForm();
  const errorContext = useContext(AlertContext);
  const tin = useModel('emulation.tin', '');
  const [, getProviders] = useProvidersSearch({
    role: 'intake-user',
    onCompleted: response => {
      const providers = response.map(provider => {
        return {
          ...provider,
          tin,
        };
      });
      setProviders(providers);
    },
    onError: error => {
      errorContext.addAlert({
        message:
          'The TIN and/or Provider Last name information entered is invalid or does not exist in our system. Please verify your entries and retry.',
      });
    },
  });

  const handleFind = () => {
    form.reset('emulation.emulatedUser');
    form.submit('emulation', model => {
      getProviders({
        variables: {
          tin: model.tin,
          providerLastName: model.providerLastName || '',
          providerFirstName: model.providerFirstName || '',
        },
      });
    });
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleFind();
    }
  };

  const handleReset = () => {
    form.reset('emulation');
    setProviders([]);
  };

  return (
    <Flex gutters-horizontal onKeyDown={handleKeyDown}>
      <Flex.Content space-33>
        <FormControl id="tin-input" model="emulation.tin" label="TIN" required>
          {(inputProps, errorProps) => (
            <React.Fragment>
              <TextInput
                {...inputProps}
                autoFocus
                validators={{ required: value => !value }}
              />
              <ErrorMessage
                {...errorProps}
                messages={{ required: 'Please enter an TIN.' }}
              />
            </React.Fragment>
          )}
        </FormControl>
      </Flex.Content>
      <Flex.Content space-33>
        <FormControl
          id="provider-first-name-input"
          model="emulation.providerFirstName"
          label="Provider First Name"
        >
          {inputProps => <TextInput {...inputProps} />}
        </FormControl>
      </Flex.Content>
      <Flex.Content space-33>
        <FormControl
          id="provider-last-name-input"
          model="emulation.providerLastName"
          label="Provider Last Name"
        >
          {inputProps => <TextInput {...inputProps} />}
        </FormControl>
      </Flex.Content>
      <Flex.Content>
        <ActionButtons>
          <Button
            data-testid="find-button"
            onClick={handleFind}
            // isLoading={getProviders.saga.isLoading}
          >
            Submit search
          </Button>
          <Button
            data-testid="reset-button"
            variant="outline"
            onClick={handleReset}
          >
            Reset
          </Button>
        </ActionButtons>
      </Flex.Content>
    </Flex>
  );
};

FindForm.propTypes = {
  setProviders: PropTypes.func,
};

FindForm.defaultProps = {
  setProviders: null,
};
